module.exports = __webpack_public_path__ + "static/media/new-logo-2.8d1e8f0b.png";